import { Film } from "lucide-react";
import { cn } from "../lib/utils";

function formatSize(bytes: number): string {
  if (bytes >= 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  return `${Math.max(1, Math.round(bytes / (1024 * 1024)))} MB`;
}

/**
 * Preview for a picked video that doesn't decode it. Playing a large local
 * video in a <video> element just to show a preview froze iOS for a moment
 * after picking it from the gallery.
 */
export function VideoFileTile({ file, className }: { file: File; className?: string }) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-md bg-muted/60 px-3 py-2 text-left",
        className
      )}
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary/15 text-primary">
        <Film className="h-5 w-5" />
      </div>
      <div className="min-w-0">
        <p className="truncate text-sm font-medium">{file.name || "Video"}</p>
        <p className="text-xs text-muted-foreground">Video · {formatSize(file.size)}</p>
      </div>
    </div>
  );
}
